import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-coupon-panel-tip',
  templateUrl: './coupon-panel-tip.component.html',
  styleUrls: ['./coupon-panel-tip.component.scss'],
})
export class CouponPanelTipComponent implements OnChanges {
  @Input() couponTipPopupStatus!: boolean;
  @Output() closePopup = new EventEmitter<boolean>();

  constructor() {}

  show = false;
  ngOnChanges(changes: SimpleChanges): void {
    this.show = changes['couponTipPopupStatus']?.currentValue;
  }

  closePopupEvent(b: boolean) {
    this.closePopup.emit(b);
  }
}
